import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => map.commands.aiGenerateReq(map.selectedNodes)

    return {
        label: '编写业务需求',
        onClick,
    }
}
